/** Espelha enrichment-core/specifications/payload (web não depende de enrichment-core). */

export type SpecSuggestionPayload = {
  fieldId: number;
  name: string;
  groupName: string;
  values: string[];
};

/** Igual ao parse estrito, mas aceita strings vazias em `values` (estado intermediário na edição). */
export function parseSpecSuggestionPayloadLoose(raw: string): SpecSuggestionPayload | null {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return null;
  try {
    const parsed = JSON.parse(trimmed) as Record<string, unknown>;
    if (
      typeof parsed.fieldId !== 'number' ||
      typeof parsed.name !== 'string' ||
      typeof parsed.groupName !== 'string' ||
      !Array.isArray(parsed.values) ||
      parsed.values.length === 0 ||
      !parsed.values.every((value) => typeof value === 'string')
    ) {
      return null;
    }
    return {
      fieldId: parsed.fieldId,
      name: parsed.name,
      groupName: parsed.groupName,
      values: parsed.values as string[],
    };
  } catch {
    return null;
  }
}

export function parseSpecSuggestionPayload(raw: string): SpecSuggestionPayload | null {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return null;
  try {
    const parsed = JSON.parse(trimmed) as Record<string, unknown>;
    if (
      typeof parsed.fieldId !== 'number' ||
      typeof parsed.name !== 'string' ||
      typeof parsed.groupName !== 'string' ||
      !Array.isArray(parsed.values) ||
      parsed.values.length === 0 ||
      !parsed.values.every((value) => typeof value === 'string' && value.trim().length > 0)
    ) {
      return null;
    }
    return {
      fieldId: parsed.fieldId,
      name: parsed.name,
      groupName: parsed.groupName,
      values: parsed.values as string[],
    };
  } catch {
    return null;
  }
}

export function formatSpecDisplay(raw: string): string {
  const payload = parseSpecSuggestionPayload(raw);
  if (!payload) return raw;
  return `${payload.name}: ${payload.values.join(', ')}`;
}

export function serializeSpecSuggestionPayload(payload: SpecSuggestionPayload): string {
  return JSON.stringify(payload);
}

export function valuesFromEditableText(text: string): string[] {
  const trimmed = text.trim();
  if (!trimmed) return [];
  return trimmed
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export function displayValueForField(field: string, raw: string): string {
  if (field === 'specifications' && raw.trim().startsWith('{')) {
    return formatSpecDisplay(raw);
  }
  return raw;
}
